module.exports = __webpack_public_path__ + "static/media/check.9643bb48.svg";